import { Button, Select } from "@chakra-ui/react";
import styled from "styled-components";

export const ProdutividadeDetalhadaContainer = styled.div`
  margin-top: 15px;
  background-color: #f9fbfb;
  font-family: Akrobat;
`;
export const ProdutividadeDetalhadaContainerText = styled.div`
  background-color: #76a5d7;
  padding: 15px 0;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const SelectBox = styled(Select)`
  font-family: Akrobat SemiBold;
  box-shadow: none !important;
`;

export const FilterContainer = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  margin: 20px 0;
  z-index: 9999;
  color: #414042;
`;
export const SelectVendedorProdutividade = styled.div`
  width: 300px;
  border-radius: 3px;
  background-color: white;
  display: flex;
  justify-content: center;
`;
export const ContentFilterSelect = styled.div`
  background-color: #fff;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding: 0 5px;
  font-size: 13px;
  margin: 0 10px;
  display: flex;
  align-items: center;

  input {
    border: 0;
    color: #919aae;
    outline: none;
  }
  label {
    width: 110px;
  }
`;

export const ButtonSelect = styled(Button)`
  border: none;
  padding: 0 13px;
  height: 38px;
  box-shadow: none !important;
`;
export const ContentGrid = styled.div`
  width: 100%;
  // height: 870px;
  position: relative;
  background-color: #f4f5f5;
`;
export const ContentGridLoading = styled.div`
  width: 100%;
  height: 150px;
  position: absolute;
  z-index: 9999;
  background-color: #f4f5f5;
  align-items: center;
`;

export const ContentGridLoadingContent = styled.div`
  width: 150px;
  height: 150px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  // background-color: brown;

  img {
    position: relative;
    margin-left: auto;
    margin-right: auto;
  }
`;
export const ContentGridTable = styled.div`
  width: 95%;
  height: 100%;
  font-family: "Akrobat";
  position: relative;
  margin-left: auto;
  margin-right: auto;
  overflow-x: scroll;
  overflow-y: hidden;
  table {
    width: 1600px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    thead {
      width: 100%;
      height: 50px;

      th {
        border: 5px solid #f4f5f5;
        // background-color: darkkhaki;
        div {
          width: 98%;
          height: 50px;
          background-color: white;
          border-radius: 5px;
          display: flex;
          align-items: center;
          p {
            width: 100%;
            position: relative;
            font-size: 12px;
            font-weight: 400;
            // color: rgb(61, 61, 61);
            letter-spacing: 0.05rem;
            color: white;
            text-align: center;
          }
        }

        &:nth-child(1) {
          width: 70px;
          div {
            background-color: #3aa7de;
            color: white;
          }
        }
        &:nth-child(2) {
          width: 90px;
          div {
            background-color: #508dca;
            color: white;
          }
        }
        &:nth-child(3) {
          width: 90px;
          div {
            background-color: #33abad;
            color: white;
          }
        }
        &:nth-child(4) {
          width: 90px;
          div {
            background-color: #7f57a2;
            color: white;
          }
        }
        &:nth-child(5) {
          width: 90px;
          div {
            background-color: #cd7a83;
            color: white;
          }
        }
        &:nth-child(6) {
          width: 90px;
          div {
            background-color: #d3a466;
            color: white;
          }
        }
        &:nth-child(7) {
          width: 90px;
          div {
            background-color: #7dbcc1;
            color: white;
          }
        }
        &:nth-child(8) {
          width: 90px;
          div {
            background-color: #d2baa1;
            color: white;
          }
        }
        &:nth-child(9) {
          width: 90px;
          div {
            background-color: #e7373e;
            color: white;
          }
        }
        &:nth-child(10) {
          width: 90px;
          div {
            background-color: #85a167;
            color: white;
          }
        }
        &:nth-child(11) {
          width: 90px;
          div {
            background-color: #18b04b;
            color: white;
          }
        }
        &:nth-child(12) {
          width: 90px;
          div {
            background-color: #88c240;
            color: white;
          }
        }
        &:nth-child(13) {
          width: 90px;
          div {
            background-color: #00a891;
            color: white;
          }
        }
        &:nth-child(14) {
          width: 90px;
          div {
            background-color: #6d6d6d;
            color: white;
          }
        }
        &:nth-child(15) {
          width: 90px;
          div {
            background-color: #f36822;
            color: white;
          }
        }
      }
    }
  }
  tfoot {
    width: 100%;
    height: 50px;

    th {
      border: 5px solid #f4f5f5;
      // background-color: darkkhaki;
      div {
        width: 98%;
        height: 50px;
        background-color: white;
        border-radius: 5px;
        display: flex;
        align-items: center;
        p {
          width: 100%;
          position: relative;
          font-size: 12px;
          font-weight: 400;
          // color: rgb(61, 61, 61);
          letter-spacing: 0.05rem;
          color: white;
          text-align: center;
        }
      }

      &:nth-child(1) {
        width: 80px;
        div {
          background-color: #f4f5f5;
          color: white;
        }
      }
      &:nth-child(2) {
        width: 120px;
        div {
          background-color: #508dca;
          color: white;
        }
      }
      &:nth-child(3) {
        width: 120px;
        div {
          background-color: #33abad;
          color: white;
        }
      }
      &:nth-child(4) {
        width: 90px;
        div {
          background-color: #7f57a2;
          color: white;
        }
      }
      &:nth-child(5) {
        width: 90px;
        div {
          background-color: #cd7a83;
          color: white;
        }
      }
      &:nth-child(6) {
        width: 90px;
        div {
          background-color: #d3a466;
          color: white;
        }
      }
      &:nth-child(7) {
        width: 90px;
        div {
          background-color: #7dbcc1;
          color: white;
        }
      }
      &:nth-child(8) {
        width: 90px;
        div {
          background-color: #d2baa1;
          color: white;
        }
      }
      &:nth-child(9) {
        width: 90px;
        div {
          background-color: #e7373e;
          color: white;
        }
      }
      &:nth-child(10) {
        width: 90px;
        div {
          background-color: #85a167;
          color: white;
        }
      }
      &:nth-child(11) {
        width: 90px;
        div {
          background-color: #18b04b;
          color: white;
        }
      }
      &:nth-child(12) {
        width: 90px;
        div {
          background-color: #88c240;
          color: white;
        }
      }
      &:nth-child(13) {
        width: 90px;
        div {
          background-color: #00a891;
          color: white;
        }
      }
      &:nth-child(14) {
        width: 90px;
        div {
          background-color: #6d6d6d;
          color: white;
        }
      }
      &:nth-child(15) {
        width: 90px;
        div {
          background-color: #f36822;
          color: white;
        }
      }
    }
  }
  tbody {
    width: 100%;
    tr {
      td {
        border-bottom: 0px solid #f4f5f5;
        border-left: 5px solid #f4f5f5;
        border-right: 5px solid #f4f5f5;

        div {
          width: 98%;
          height: 20px;
          background-color: white;
          border-radius: 5px;
          display: flex;
          align-items: center;
          border: 1px solid rgba(0, 0, 0, 0.137);

          p {
            cursor: pointer;
            width: 100%;
            position: relative;
            font-size: 12px;
            // color: rgb(61, 61, 61);
            letter-spacing: 0.05rem;
            color: rgb(61, 61, 61);
            text-align: center;

            &:nth-child(2) {
              opacity: 0.8;
            }
          }
        }
        &:nth-child(1) {
          div {
            cursor: pointer;
          }
        }
      }
    }
  }
`;
